import React from 'react'

const PaintingList = () => {
  return (
    <div>PaintingList</div>
  )
}

export default PaintingList